
const routes = [

  {
    path: '/st',
    name: 'st-login',
    component: () => import(/* webpackChunkName: "st-login" */ '@/views/st/Login.vue')
  },
  {
    path: '/st',
    component: () => import(/* webpackChunkName: "st-layout" */ '@/views/st/_Layout.vue'),
    children: [
      {
        path: 'forside',
        name: 'st-home',
        component: () => import(/* webpackChunkName: "st-home" */ '@/views/st/Home.vue')
      },
      {
        path: 'velg-apotek',
        name: 'st-pharmacy-select',
        component: () => import(/* webpackChunkName: "st-home" */ '@/views/st/Pharmacy_Select.vue')
      },
    ]
  }

]

export default routes